import { deprecatedCustomerAnalyzeRoutes } from "./customerRouteConfigs/analyze-routes";
import { deprecatedCustomerBillingRoutes } from "./customerRouteConfigs/billing-routes";
import { deprecatedCustomerIntegrateRoutes } from "./customerRouteConfigs/integrate-routes";
import { deprecatedCustomerMonitorRoutes } from "./customerRouteConfigs/monitor-routes";
import { deprecatedCustomerOperateRoutes } from "./customerRouteConfigs/operate-routes";
import { deprecatedCustomerOptimizeRoutes } from "./customerRouteConfigs/optimize-routes";
import { type DeprecatedCustomerRouteConfig } from "./deprecatedRoutePageIdTypes";

export const deprecatedCustomerRoutes: DeprecatedCustomerRouteConfig[] = [
  ...deprecatedCustomerOperateRoutes,
  ...deprecatedCustomerAnalyzeRoutes,
  ...deprecatedCustomerMonitorRoutes,
  ...deprecatedCustomerIntegrateRoutes,
  ...deprecatedCustomerOptimizeRoutes,
  ...deprecatedCustomerBillingRoutes,
];
